/*
*
* File JS componente HEADER
*
*/


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './header.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const html = document.querySelector('html');
const body = document.querySelector('body');
const header = document.querySelector('header');
const headerWrap = document.querySelector('header .header-wrap');
const menuContainer = document.querySelector('header .header-wrap .menu-container');
const hamburgerBtn = document.querySelector('.header-wrap .header__burger');

const linksWithSubMenu = document.querySelectorAll('header .header-wrap .main-menu > ul > li.dropdown');
const anchorLinksSubMenu = document.querySelectorAll('header .header-wrap .main-menu > ul > li.dropdown > a');


/**
*	Funzione di gestione apertura/chiusura menu mobile
*
*	@return {void}
*/
const manageMenuMobile = () =>
{
    hamburgerBtn.addEventListener('click', () =>
    {
        if (hamburgerBtn.classList.contains('open'))
        {
            header.classList.remove('open-menu');
            headerWrap.classList.remove('open-menu');
            hamburgerBtn.classList.remove('open');
            body.classList.remove('open-menu-mobile');
            html.classList.remove('ovfw-hid-nav-mob');

        }
        else
        {
            heightMenuMobile();
            header.classList.add('open-menu');
            headerWrap.classList.add('open-menu');
            hamburgerBtn.classList.add('open');
            body.classList.add('open-menu-mobile');
            html.classList.add('ovfw-hid-nav-mob');
        }
    });

    // Chiusura tasto ESC
    document.addEventListener('keyup', (evt) =>
    {
        if(evt.code === 'Escape')
        {
            if (!hamburgerBtn.classList.contains('open')) return;
            
            header.classList.remove('open-menu');
            headerWrap.classList.remove('open-menu');
            hamburgerBtn.classList.remove('open');
            body.classList.remove('open-menu-mobile');
            html.classList.remove('ovfw-hid-nav-mob');
        }
    });
}


/**
*	Funzione di apertura del submenu
*
*	@return {void}
*/
const openSubMenu = (el) =>
{
    el.classList.add('open');
    headerWrap.classList.add('open-submenu');

    if (window.innerWidth >= 1024)
    {
        el.querySelector(':scope > .dropdown-menu').style.height = '';
    }
    else
    {
        let heightSubmenu = 0;
        let elementsInSub = el.querySelectorAll(':scope > .dropdown-menu > li');

        elementsInSub.forEach(element => 
        {
            heightSubmenu = heightSubmenu + element.offsetHeight;
        });

        el.querySelector(':scope > .dropdown-menu').style.height = heightSubmenu + 'px';
    }

}


/**
*	Funzione di chiusura del submenu
*
*	@return {void}
*/
const closeSubMenu = (el) =>
{
    el.classList.remove('open');
    headerWrap.classList.remove('open-submenu');

    if (window.innerWidth >= 1024) return;

    el.querySelector(':scope > .dropdown-menu').style.height = '';
}


/**
*	Funzione di chiusura di tutti i submenu
*
*	@return {void}
*/
const closeAllSubMenu = () => 
{
    linksWithSubMenu.forEach(el => {
        closeSubMenu(el);
    });
}


/**
*	Funzione per la gestione dell'apertura/chiusura dei submenu
*
*	@return {void}
*/
const manageSubMenu = () => 
{
    const iconDropdown = '<div class="submenu-indicator"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" shape-rendering="geometricPrecision" class="icons-open-down"><use xlink:href="' + templateUrl + '/assets/build/spritemap.svg#ico_down"></use></svg></div>';

    for (let i = 0; i < linksWithSubMenu.length; ++i) 
    {
        // Add icon dropdown
        linksWithSubMenu[i].innerHTML = linksWithSubMenu[i].innerHTML + iconDropdown;

        // START - EventListener Navbar expanded
        linksWithSubMenu[i].addEventListener('mouseover', () => 
        {
            if (window.innerWidth < 1024) return;

            openSubMenu(linksWithSubMenu[i]);
        });

        linksWithSubMenu[i].addEventListener('mouseleave', () => 
        {
            if (window.innerWidth < 1024) return;

            closeSubMenu(linksWithSubMenu[i]);
        });
        // END - EventListener Navbar expanded

        // START - EventListener Navbar compressed
        linksWithSubMenu[i].querySelector('.dropdown-toggle').addEventListener('click', (evt) => 
        {
            if (window.innerWidth >= 1024) return;

            if (!linksWithSubMenu[i].classList.contains('open'))
            {
                evt.preventDefault();
                openSubMenu(linksWithSubMenu[i]);
            }
        });

        linksWithSubMenu[i].querySelector('.submenu-indicator').addEventListener('click', (evt) =>
        {

            if (linksWithSubMenu[i].classList.contains('open'))
            {
                closeSubMenu(linksWithSubMenu[i]);
            }
            else
            {
                openSubMenu(linksWithSubMenu[i]);
            }
        });
        // END - EventListener Navbar compressed
    }
}


/**
*	Funzione per calcolo altezza menu mobile 
*
*	@return {void}
*/
const heightMenuMobile = () =>
{
    let wHeight = window.innerHeight;
    let wWidth = window.innerWidth;
    let offsetTopElements = 0;

    var topbar = document.querySelector('#top-bar');

    var topbarHeight = topbar ? topbar.offsetHeight : 0;

    if (wWidth < 1024)
    {
        if (body.classList.contains('scroll-detect'))
        {
            offsetTopElements = document.querySelector('header .header-container').offsetHeight;
        }
        else
        {
            offsetTopElements = topbarHeight + document.querySelector('header .header-container').offsetHeight;
        }

        menuContainer.style.height = (wHeight - offsetTopElements) + 'px';
    }
    else
    {
        menuContainer.style.height = '';
    }
}


/**
*	Funzione per la gestione dell'animazione allo scroll della navbar
*
*	@return {void}
*/
function scrollDetectNav()
{
    var scrollUp = 'scroll-up';
    var scrollDown = 'scroll-down';
    var scrollDetect = 'scroll-detect';
    var lastScroll = 0;

    var topbar = document.querySelector('#top-bar');

    var topbarHeight = topbar ? topbar.offsetHeight : 150;
    var navbarHeight = document.querySelector('header').offsetHeight;

    window.addEventListener('resize', function()
    {
        topbarHeight = document.querySelector('#top-bar') ? document.querySelector('#top-bar').offsetHeight : 150;
        navbarHeight = document.querySelector('header').offsetHeight;
    });


    //Funzione per cambiare il logo allo scroll
    var logoHeader = document.querySelector('header .logo img');

    const manageLogo = () => {
        if (body.classList.contains(scrollDown) || body.classList.contains(scrollUp)) {
            logoHeader.src = logoColor;
        } else {
            logoHeader.src = logoWhite;
        }
    }

    manageLogo();

    window.addEventListener('scroll', manageLogo);
    window.addEventListener('resize', manageLogo);




    const manageScroll = () => {
        const currentScroll = window.pageYOffset;
        
        if (currentScroll <= topbarHeight) 
        {
            body.classList.remove(scrollUp, scrollDetect);
            return;
        }
        
        if (currentScroll > lastScroll && !body.classList.contains(scrollDown) && currentScroll >= topbarHeight) 
        {
            // Scroll Down
            body.classList.add(scrollDetect);
            
            if (currentScroll >= topbarHeight)
            {
                body.classList.remove(scrollUp);
                body.classList.add(scrollDown);
            }
        } 
        else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) 
        {
            // Scroll Up
            body.classList.remove(scrollDown);
            body.classList.add(scrollUp);
        }
        lastScroll = currentScroll;
    }
    manageScroll();
    

    window.addEventListener('scroll', manageScroll);
}

/**
 * Set Cookie
 */
function setCookie(cname, cvalue, exdays)
{
    let days = null;
    if (0 !== exdays) {
        days = (exdays * 24 * 60 * 60 * 1000);
    } else {
        days = 0
    }

    let now = new Date();
    now.setTime(now.getTime() + days);
    let expires = "expires=" + now.toUTCString();

    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/**
 * Get Cookie
 */
function getCookie(cname)
{
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return false;
}


/**
*	Funzione di init per tutte le funzioni del componente Header
*
*	@return {void}
*/
const initHeader = () =>
{
    manageMenuMobile();
    manageSubMenu();
    heightMenuMobile();
    scrollDetectNav();

    window.addEventListener('resize', () => {
        closeAllSubMenu();
        heightMenuMobile();
    });

    document.addEventListener('keydown', (evt) => {
        if(evt.key === "Escape"){
            closeAllSubMenu();
        }
    });
}

/**
 * Popup events
 */
 window.addEventListener("load", function(){
     setTimeout(
         function open(event){
             let popup = document.querySelector(".popup");
             if (popup) {
                 let podcastID = popup.getAttribute('data-podcast');
                 let expired = popup.getAttribute('data-expired');
                 let time = popup.getAttribute('data-time');

                 if (parseInt(time) > parseInt(expired)) {
                     return;
                 }

                 if (podcastID) {
                     let cookie = getCookie('_podcast_'+podcastID+'_popup_live');
                     //console.log('cookie_value', cookie);

                     if (! cookie) {
                         // Set cookie value 1 for show popup
                         setCookie('_podcast_'+podcastID+'_popup_live', 1, 1);
                         cookie = getCookie('_podcast_'+podcastID+'_popup_live');
                     }

                     if (1 === parseInt(cookie)
                         // Display even if value 2 (modification required)
                         || 2 === parseInt(cookie)
                     ) {
                         popup.style.display = "block";
                     }
                 }
             }
         },
         2000
     )

     let popupClose = document.querySelector("#close");
     if (popupClose) {
         popupClose.addEventListener("click", function () {
             let popup = document.querySelector(".popup");
             if (popup) {
                 let podcastID = popup.getAttribute('data-podcast');
                 if (podcastID) {
                     let cookie = getCookie('_podcast_' + podcastID + '_popup_live');
                     if (cookie) {
                         // Set cookie value 2 for hide popup
                         setCookie('_podcast_' + podcastID + '_popup_live', 2, 1)
                     }
                 }

                 popup.style.display = "none";
             }
         });
     }
 });

export default initHeader;

//--------------------------------------------------------------------//